import { useSuspenseQuery } from "@apollo/client";
import { useParams } from "react-router";
import { WASTE_LINES_UNIFIED_QUERY } from "routes/Customer/Waste/ManifestLineItems/api";

import { useCurrentUser } from "./useCurrentUser";

export const useWasteLineUnifiedSuspense = (
  wasteLineUnifiedId: string | undefined,
  // Explicit tenant for cross-tenant (staff) callers off a tenant-scoped route.
  tenantIdOverride?: string
) => {
  const { tenantId: routeTenantId } = useParams<{ tenantId: string }>();
  const tenantId = tenantIdOverride ?? routeTenantId;
  const { isStaff, loading: userLoading } = useCurrentUser();
  const { data } = useSuspenseQuery(WASTE_LINES_UNIFIED_QUERY, {
    variables: {
      search: `tenantId:${tenantId} id:${wasteLineUnifiedId}`,
      page: 0,
      pageSize: 1,
      includeOriginalVendorWasteLine: isStaff,
    },
    skip: !tenantId || !wasteLineUnifiedId || userLoading,
  });

  return {
    data,
    lineItem: data?.wasteLinesUnified?.items?.[0],
  };
};
